import { Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DateFilterStore, RangeDateFilterStore, TextFilter } from '../../../common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class QuotesFiltersService {
    constructor(http, injector) {
        this.http = http;
        this.injector = injector;
        this.textFilter = new TextFilter('athlete-quotes-id');
        this.rangeDate = new RangeDateFilterStore("range_date", new DateFilterStore("from", "From", undefined, undefined, new BehaviorSubject({ value: undefined }), undefined, new Date(), 'date_from_quote'), new DateFilterStore("to", "To", undefined, undefined, new BehaviorSubject({ value: new Date() }), undefined, undefined, 'date_to_quote'));
        this.filters = [
            // We don't have implementation for backend.
            //this.textFilter.filterInfo,
            this.rangeDate.filterInfo
        ];
        this.rangeDate.filterInfo.options.date_to.max_date = new Date();
        this.filter_athlete_service = injector.get(FiltersAthleteGeneralService);
    }
    get quotesStore() {
        return this.filter_athlete_service.athleteQuotesStore;
    }
}
QuotesFiltersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QuotesFiltersService_Factory() { return new QuotesFiltersService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.INJECTOR)); }, token: QuotesFiltersService, providedIn: "root" });
